//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

//import qs from "qs";

import parsePhoneNumber from 'libphonenumber-js'

// Parse number with country code and keep raw input.


export default {
  props: {
    place: {
      default: false
    },
    
  },

  computed: {
    itinerary: function() {
      return this.currentItinerary;
    },
  },
  watch: {

  },
  components: {

  },
  filters: {

  },
  data() {
    return { 
      

    }
  },
  mounted() {


  },
  methods: {
    formatNumber(phone) {
      let phoneNumber = parsePhoneNumber(phone, 'US')
      console.log('PHONE NUMBER', phoneNumber)
      if ( phoneNumber ) {
        return phoneNumber.formatNational()
      } else {
        return false
      }
      //let number = phoneUtil.parseAndKeepRawInput(phone, 'US');
    },
    getThumbnail(place) {
      //.replace('_o', '_t')
      return 'https://api.everwondr.com'+place.items[0].upload_source.replace('_o.', '_n.');
    },
    searchPlaces() {
      this.search.page = 1;
      this.places = [];
      this.clearResults = true;

      this.getPlaces();

    },
    togglePlannerItinerary(place) {

      let venue = place.venue;

      if ( place.items.length ) {
        venue.thumbnail = place.items[0].upload_source;
      }

      venue.data_type = 'venue';

      let raw = JSON.stringify( venue );

      //console.log('VENUE____', venue)

      //return false;

      let object = {
        itinerary_id: this.currentSession.id,
        name: venue.name,
        venue_name: null,
        data_type: 'venue',
        object_id: venue.id,
        thumbnail: 'https://api.everwondr.com'+venue.thumbnail,
        address_1: venue.address_1,
        city: venue.city,
        state: venue.state,
        zip: venue.zip,
        lat: venue.lat,
        email: venue.email,
        phone: venue.phone,
        website: venue.website,
        lng: venue.lng,
        raw_object: raw,
        tags: venue.venue_types
      };

      this.toggleItineraryItem(object);

      //this.$store.commit('toggleItinerary', object);

      this.$forceUpdate();

    },
    inPlanner(listing) {
      listing.data_type = 'venue';


      
      listing.object_id = parseInt(listing.id);
      return this.itineraryHasItem(listing);
    },
    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Venue.vue